import { Typography } from '@loophealth/loop-ui-web-library';
import { motion } from 'framer-motion';
import React from 'react';
import { HospitalMaterialIcon } from '../../../../assets/img';
import { CheckMarkOutlined } from '../../../../assets/img/CustomIcons/CheckMarkOutlined';
import {
    StyledAttributeConditionIcon,
    StyledUserAttributesConditionItem,
    StyledUserAttributesConditions,
    StyledUserAttributesConditionsWrapper
} from './styles';
import { useSelector } from 'react-redux';
import { selectUserAttributes } from '../../../pages/LoginContainer/redux/slices/UserSlice/selectors';

interface IUserAttributesConditionsProps {
    selectedConditions: string[];
    setSelectedConditions: React.Dispatch<React.SetStateAction<string[]>>;
}

const UserAttributesConditions: React.FC<IUserAttributesConditionsProps> = ({
    selectedConditions,
    setSelectedConditions
}) => {
    const userAttributes = useSelector(selectUserAttributes);
    const conditions = userAttributes.data?.conditions ?? [];
    useSelector(selectUserAttributes);

    const handleToggleCondition = (conditionId: string) => {
        setSelectedConditions((prev) => {
            if (prev.includes(conditionId)) {
                return prev.filter((id) => id !== conditionId);
            } else {
                return [...prev, conditionId];
            }
        });
    };
    return (
        <StyledUserAttributesConditionsWrapper>
            <Typography variant="small" weight="medium">
                Tell us what matters most to your health and lifestyle&nbsp;
                <Typography variant="small" color="secondary">
                    (Select all that apply)
                </Typography>
            </Typography>
            <StyledUserAttributesConditions>
                {conditions.map((c) => {
                    const isSelected = selectedConditions.includes(c.conditionId);

                    return (
                        <StyledUserAttributesConditionItem
                            key={c.conditionId}
                            $isSelected={isSelected}
                            onClick={() => handleToggleCondition(c.conditionId)}
                            layout
                        >
                            <StyledAttributeConditionIcon
                                layout
                                src={c.imageUrl ?? HospitalMaterialIcon}
                                alt="condition icon"
                            />
                            <motion.div layout>
                                <Typography
                                    variant="medium"
                                    weight={isSelected ? 'medium' : 'regular'}
                                    color={isSelected ? 'emerald' : 'primary'}
                                >
                                    {c.displayName}
                                </Typography>
                            </motion.div>
                            {isSelected && <CheckMarkOutlined />}
                        </StyledUserAttributesConditionItem>
                    );
                })}
            </StyledUserAttributesConditions>
        </StyledUserAttributesConditionsWrapper>
    );
};

export default UserAttributesConditions;
